// import { userInfos } from '../../../../api/account'
import {
  laxinInviteList,
  laxinShareInfo,
  laxinTeamInfo
} from '../../../../api/laxin'
import { isArray } from '../../../../utils/xp.v1'

export default {
  async bind({ dispatch, state }) {
    const { teamUid } = state
    if (teamUid > 0) {
      dispatch('laxin/bind', { srcUid: teamUid, bindType: 2 }, { root: true })
    }
  },

  async load({ state, dispatch, getters }, { uid }) {
    uid = +uid || 0
    state.teamUid = uid
    await dispatch('laxin/loadPriv', {}, { root: true })

    const { myUid } = getters
    if (uid > 0) {
      // const users = await userInfos({ uids: uid }).then(
      //   (A) => A.list,
      //   () => []
      // )
      // if (users.length > 0) {
      //   dispatch('laxin/mergeUsers', array2map(users, 'uid'), { root: true })
      // }
      const usersMap = await laxinShareInfo({
        shareId: uid,
        shareType: 2
      }).then(
        (A) => A.userInfosMap,
        () => []
      )
      dispatch('laxin/mergeUsers', usersMap, { root: true })

      state.inviteList = []
      state.inviteInfo = null
      const B = await laxinTeamInfo({}).then(
        (A) => A,
        () => null
      )
      if (B) {
        const { inviteInfo, teamList } = B
        if (inviteInfo) {
          // 仅保存普通拉新类型
          state.inviteInfo = inviteInfo && inviteInfo.type === 2 ? inviteInfo : null
          if (inviteInfo.uid === +uid && isArray(teamList)) {
            state.inviteList = teamList
          }
        }
        dispatch('laxin/mergeUsers', B.userInfosMap, { root: true })
      }

      if (uid === myUid) {
        const A = await laxinInviteList({ uid }).then(
          (A) => A,
          () => null
        )
        if (A) {
          state.inviteList = isArray(A.inviteList) ? A.inviteList : []
          dispatch('laxin/mergeUsers', A.userInfosMap, { root: true })
        }
      }
    }
  }
}
